import { Component, OnInit } from '@angular/core';
import { ApplicationRoles, EdlFeatureFlags, FileDownloadHandler, PortalHelpers, SessionService, User } from '@edl-development/edl-common';
import { A48ReportTypes } from '../enums/reports/a48-reports.enum';
import { UserHelper } from '../model/helpers/user.helper';
import { MetricService } from '../services/metric.service';
import { CplItemSubType } from '../model/enum/cpl-item-sub-type.enum';
import { TimeTrackingTypes } from '../model/enum/cpl-time-tracking-type.enum';

@Component({
    templateUrl: './reports.component.html'
})
export class ReportsComponent implements OnInit{
    
    busy:Boolean;
    user: User;
    isParaEducator: boolean;
    isEmergencyCert: boolean;
    isVolunteerEnabled: boolean = false;

    ApplicationRoles = ApplicationRoles;
    A48ReportTypes = A48ReportTypes;
    CplItemSubType = CplItemSubType;
    TimeTrackingTypes = TimeTrackingTypes;

    constructor(
        private metricService: MetricService,
        private sessionService: SessionService,
        private fileHandler: FileDownloadHandler
    ) {}

    ngOnInit() {
        this.user = this.sessionService.user;
        this.isParaEducator = UserHelper.isParaeducator(this.user);
        this.isEmergencyCert = UserHelper.isEmergencyCert(this.user);
        this.isVolunteerEnabled = PortalHelpers.isFeatureFlagEnabled(this.sessionService.PortalSettings, EdlFeatureFlags.VolunteersEnabled);
    }

    getUserGrowthMetrics(){
        
            this.busy = true;
            this.metricService
                .getUserGrowthExcel()
                .subscribe((fileResponse: Blob) => {
                    this.fileHandler.saveFile(fileResponse, "Edulink_User_Growth_Report.xlsx");
                    
                },
                (error) => {
                    this.busy = false; 
                },() => {
                    this.busy = false; 
                });
        
    }


}